import dayjs from "dayjs";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import RichText from "@/components/atoms/rich-text/rich-text";
import { SPREAD_THE_COST } from "@/constants";
import { AgreementContentSchemaType } from "@/schema/renewal-page/payment-summary-page.schema";
import { RootState } from "@/store/root-reducer";
import { isSameDate } from "@/utils/travel-date.utils";

export function PriceSummaryInfo({
  priceSummaryParagraphOne,
  priceSummaryParagraphTwo,
  priceSummaryParagraphThree,
}: AgreementContentSchemaType) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const payOption = useSelector((state: RootState) => state.paymentConsents);
  const { tripDetails } = attributes;

  const isMonthly: boolean = payOption.type === SPREAD_THE_COST;

  const isSamedate = useMemo(() => {
    if (!tripDetails?.startDate) return false;

    return !isSameDate(new Date(tripDetails.startDate));
  }, [tripDetails?.startDate]);

  const priceSummaryParagraphTwoWithStartDate = useMemo(() => {
    return priceSummaryParagraphTwo.replace(
      "&lt;POLICY_START_DATE&gt;",
      `<span className="whitespace-nowrap">${dayjs(tripDetails?.startDate)
        .format("DD-MM-YYYY")
        .toString()}</span>`
    );
  }, [priceSummaryParagraphTwo, tripDetails?.startDate]);

  return (
    <>
      {isMonthly && (
        <>
          <div className="mt-spacing-xxs text-dark-text-functional font-body-font text-3xs leading-[150%]">
            <RichText
              richText={priceSummaryParagraphOne}
              className="flex flex-col gap-spacing-l [&>ul]:list-disc [&>ul>li]:marker:text-4xs [&>ul]:ml-[27px] [&>ul>li]:pb-spacing-xs [&>ul>li:last-child]:pb-0"
            />
          </div>
          {isSamedate && (
            <div className="text-dark-text-functional font-body-font text-3xs leading-[150%]">
              <RichText
                richText={priceSummaryParagraphTwoWithStartDate}
                className="flex flex-col gap-spacing-l break-words [&>ul]:list-disc [&>ul>li]:marker:text-4xs [&>ul]:ml-[27px] [&>ul>li]:pb-spacing-xs [&>ul>li:last-child]:pb-0"
              />
            </div>
          )}
        </>
      )}
      <div className="text-dark-text-functional font-body-font text-3xs leading-[150%]">
        <RichText
          richText={priceSummaryParagraphThree}
          className="flex flex-col gap-spacing-l [&>ul]:list-disc [&>ul>li]:marker:text-4xs [&>ul]:ml-[27px] [&>ul>li]:pb-spacing-xs [&>ul>li:last-child]:pb-0"
        />
      </div>
    </>
  );
}
